import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/app/apps/frontend/src/middleware/auth.global.ts";
import track_45global from "/app/apps/frontend/src/middleware/track.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  track_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "can-create-course": () => import("/app/apps/frontend/src/middleware/canCreateCourse.ts"),
  "is-teacher": () => import("/app/apps/frontend/src/middleware/isTeacher.ts"),
  "scroll-top": () => import("/app/apps/frontend/src/middleware/scrollTop.ts")
}